import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import NotificationBell from './NotificationBell';
import SearchBar from '../SearchBar';
import { FaSearch, FaWater, FaHome, FaMapMarkedAlt, FaBlog, FaBriefcase, FaUserCircle, FaTachometerAlt, FaSignOutAlt } from 'react-icons/fa';
import './Navbar.css';

const Navigation = () => {
  const { currentUser, logout, isAdmin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [showSearch, setShowSearch] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Scroll detection for blur effect
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path) => location.pathname === path;

  return (
    <Navbar bg="dark" variant="dark" expand="lg" className={`navbar-custom ${scrolled ? 'scrolled' : ''}`}>
      <Container fluid>
        <Navbar.Brand as={Link} to="/">
          <FaWater />
          DiveConnect
        </Navbar.Brand>
        
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/" className={`nav-link ${isActive('/') ? 'active' : ''}`}>
              <FaHome /> Home
            </Nav.Link>
            <Nav.Link as={Link} to="/trips" className={`nav-link ${isActive('/trips') ? 'active' : ''}`}>
              <FaMapMarkedAlt /> Trips
            </Nav.Link>
            <Nav.Link as={Link} to="/blog" className={`nav-link ${isActive('/blog') ? 'active' : ''}`}>
              <FaBlog /> Blog
            </Nav.Link>
          </Nav>
          
          {/* Search Bar - Desktop */}
          <div className="navbar-search d-none d-lg-block mx-3">
            <SearchBar />
          </div>
          
          {/* Search Toggle - Mobile */}
          <Button 
            variant="outline-light" 
            className="d-lg-none me-2 search-toggle-btn"
            onClick={() => setShowSearch(!showSearch)}
          >
            <FaSearch />
          </Button>
          
          <Nav>
            {currentUser ? (
              <>
                <Nav.Link as={Link} to="/my-trips" className={`nav-link ${isActive('/my-trips') ? 'active' : ''}`}>
                  <FaBriefcase /> My Trips
                </Nav.Link>
                
                <NotificationBell />
                
                {isAdmin && isAdmin() && (
                  <Nav.Link as={Link} to="/admin" className={`nav-link ${isActive('/admin') ? 'active' : ''}`}>
                    <FaTachometerAlt /> Admin
                  </Nav.Link>
                )}
                
                <Nav.Link as={Link} to="/profile" className={`nav-link ${isActive('/profile') ? 'active' : ''}`}>
                  <FaUserCircle /> Profile
                </Nav.Link>
                
                <Button 
                  variant="danger" 
                  onClick={() => {
                    logout();
                    navigate('/');
                  }}
                  className="ms-2"
                >
                  <FaSignOutAlt /> Logout
                </Button>
              </>
            ) : (
              <>
                <Nav.Link as={Link} to="/login" className={`nav-link ${isActive('/login') ? 'active' : ''}`}>
                  Login
                </Nav.Link>
                <Button 
                  variant="primary" 
                  as={Link} 
                  to="/register"
                  className="ms-2"
                >
                  Register
                </Button>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
        
        {/* Mobile Search Bar */}
        {showSearch && (
          <div className="mobile-search-container d-lg-none">
            <SearchBar onClose={() => setShowSearch(false)} />
          </div>
        )}
      </Container>
    </Navbar>
  );
};

export default Navigation;